/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type {
  PasswordResetErrorResponse,
  PasswordResetRequest,
  PasswordResetResponse,
} from './api.schemas';

import { api } from '../util/http';

export const passwordReset = (passwordResetRequest: PasswordResetRequest, signal?: AbortSignal) => {
  return api<PasswordResetResponse>({
    url: `/api/auth/password-reset`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: passwordResetRequest,
    signal,
  });
};

export const getPasswordResetMutationOptions = <
  TError = PasswordResetErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof passwordReset>>,
    TError,
    { data: PasswordResetRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof passwordReset>>,
  TError,
  { data: PasswordResetRequest },
  TContext
> => {
  const mutationKey = ['passwordReset'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof passwordReset>>,
    { data: PasswordResetRequest }
  > = (props) => {
    const { data } = props ?? {};

    return passwordReset(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PasswordResetMutationResult = NonNullable<Awaited<ReturnType<typeof passwordReset>>>;
export type PasswordResetMutationBody = PasswordResetRequest;
export type PasswordResetMutationError = PasswordResetErrorResponse;

export const usePasswordReset = <TError = PasswordResetErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof passwordReset>>,
      TError,
      { data: PasswordResetRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof passwordReset>>,
  TError,
  { data: PasswordResetRequest },
  TContext
> => {
  const mutationOptions = getPasswordResetMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
